import StoresControl from './StoresControl';
import environment from '../environment';

export class StoreInactiveControl extends StoresControl {
  constructor () {
    const options = {
      name: 'StoreInactive',
      context: 'LAYER_NETWORK',
      stores: environment.get('CONFIG.DEALERS')
    };

    super(options);
  }

  static getInstance () {
    if (!StoreInactiveControl._instance) {
      StoreInactiveControl._instance = new StoreInactiveControl();
    }

    return StoreInactiveControl._instance;
  }
}

export default StoreInactiveControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/StoreInactiveControl.js